import styled from 'styled-components';

import { SIZE, BLUE, FOOTER_GREY, BORDER } from '../../const';

export const StyledFooter = styled.footer`
    font-family: Open Sans;
    background: ${FOOTER_GREY};
    padding-bottom: 20px;
    border-top: ${BORDER};

    @media ${SIZE.laptopL} {
        padding: 0 0 20px;
    }

    @media ${SIZE.screenMd} {
        height: auto;
    }

    .copyright {
        display: inline-block;
        text-align: center;
        color: #4d4d4d;
        padding: 16px;
    }

    .container {
        width: calc(100% - 30px);
        margin: 0 auto;

        
        @media ${SIZE.screenLgMin} {
            max-width: 1170px;
        }
        @media ${SIZE.screenLg1600min} {
            max-width: 1440px;
        }
        @media ${SIZE.screenMd} {
            max-width: 970px;
        }

        .socials {
            width: 100%;
            margin-top: 15px;
            display: flex;
            justify-content: center;
        }
    }
    
`;

export const StyledLinkSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: calc(100% - 30px);
    margin: 0 auto;
    max-width: 1440px;
    padding-top: 25px;
    padding-bottom: 20px;
    
    border-bottom: 1px solid #ddd;

    @media ${SIZE.laptopL} {
        padding: 20px;
    }
    @media ${SIZE.screenMd} {
        max-width: 970px;
        flex-direction: column;
        text-align: center;
    }

    .block {
        display: flex;
        flex-direction: column;
        font-size: 16px;
        line-height: 22px;

        &_links {
            display: flex;
            flex-direction: column;
        }

        @media ${SIZE.screenMd} {
           margin-bottom: 0;
        }

        a {
            font-size: 16px;
            line-height: 28px;
            padding: 5px 0;
            @media ${SIZE.screenMd} {
                padding: 16px 0;
            }
        }

        .title {
            color: #4d4d4d;
            font-size:21px;
            font-weight: bold;
            margin: 0 0 20px 0;
        }
    }
`;

export const StyledLinkSectionMobile = styled(StyledLinkSection)`
    display: none;

    .block {
        padding: 16px 0;

        .title {
            color: ${BLUE};
            font-size: 16px;
            font-weight:400;
            line-height:28px;
        }
    }

    @media ${SIZE.screenMd} {
        display: flex;
    }
`;

export const StyledSocialMedia = styled.div`
    width: ${props => props.small ? "auto": "100%"};
    text-align: ${props => props.small ? "right": "center"};
    max-width: 230px;

    a {
        margin-right: 12px;

        img {
            width: 26px;
            height: 32px;
        }
    }

    @media ${SIZE.screenMd} {
        display: flex;
        justify-content: space-around;
        align-items: center;

        a {
            overflow:hidden;
        }
    }
`;

export const StyledExtraLines = styled.div`
    text-align: center;
    margin-top: 15px;

    @media ${SIZE.screenMd} {
        display: flex;
        flex-direction: column;
    }

    a, span {
        padding: 16px;
    }

    a {
        @media ${SIZE.screenMd} {
            padding: 16px;
            margin-right: 0;
        }
    }

    span {
        @media ${SIZE.screenMd} {
            display: none;
        }
    }
`